import { FieldErrors, FieldPath, FieldValues, useFormState } from "react-hook-form";

type Props<TFieldValues extends FieldValues, TFieldName extends FieldPath<TFieldValues>> = {
    children: (errors: FieldErrors<TFieldValues>[TFieldName]) => React.ReactNode;
    name: TFieldName;
};

export const FormFieldErrors = <TFieldValues extends FieldValues, TFieldName extends FieldPath<TFieldValues>>({
    children,
    name,
}: Props<TFieldValues, TFieldName>) => {
    const { errors } = useFormState<TFieldValues>({ name });
    return <>{children(errors[name])}</>;
};
